const SELECTABLE_IS_INTERACTIVE = "selectable-interactive";

export { SELECTABLE_IS_INTERACTIVE as S };
